export const API_PATH_ApiDeviceMgmtDevicesConfigGet = '/services/devices-mgtm/apiDeviceMgmtDevicesConfigGet';
